import sileo from 'sileo';

const HRLeaveCreditChange = new sileo.Model('hqzen', 'hr-leave-credit-change');
const HRLeaveRequestList = new sileo.Model('hqzen', 'hr-leave-request-list');
const HRWorkforcesList = new sileo.Model('hqzen', 'hr-workforces-list');
const HREmployeeLeaveCreditsList = new sileo.Model('hqzen', 'hr-portal-elc-list');
const HRLeavesAdminList = new sileo.Model('hqzen', 'hr-portal-leave-admin-list');
const HRPortalLeaveHistory = new sileo.Model('hqzen', 'hr-portal-leave-history-log');
const CareerPolicyList = new sileo.Model('hqzen', 'career-policy-list');
const HRPortalLeaveDetails = new sileo.Model('hqzen', 'hr-portal-leave-details');
const HR201FilesList = new sileo.Model('hqzen', 'hr-201-files-list');
const HR201RequirementsCount = new sileo.Model('hqzen', 'hr-201-requirements-count');
const HRPartnersList = new sileo.Model('hqzen', 'hr-partners-list');
const HRDeactivatedPartners = new sileo.Model('hqzen', 'hr-deactivated-employments');
const ApplicantRequirements = new sileo.Model('hqzen', 'applicant-requirements');
const HRAccountabilitiesList = new sileo.Model('hqzen', 'hr-accountabilities-list');
const HRAccountabilitiesDetails = new sileo.Model('hqzen', 'hr-accountability-details');
const HRAccountability = new sileo.Model('hqzen', 'hr-accountabilities');
const HRAccountabilityEmployees = new sileo.Model('hqzen', 'hr-accountability-employees');
const HRAccountabilityEditHistory = new sileo.Model('hqzen', 'hr-accountability-edit-history');
const HRPartnerDetails = new sileo.Model('hqzen', 'hr-partner-details');
const HRIncidentReports = new sileo.Model('hqzen', 'hr-incident-report');
const HRDisciplinaryActionForm = new sileo.Model('hqzen', 'hr-disciplinary-action-forms-resource');
const DAFAmazon = new sileo.Model('hqzen', 'daf-amazon-form-data');
const PolicyAction = new sileo.Model('applybpo', 'policy-action');
const HRPortalFetchAllWorkforces = new sileo.Model('hqzen', 'hr-company-workforce');
const HRPortalFetchAllDepartments = new sileo.Model('hqzen', 'hr-workforce-departments');
const HRPortalFetchAllTeams = new sileo.Model('hqzen', 'hr-employee-teams');
const HRDAFAppeal = new sileo.Model('hqzen', 'hr-appeal');
const updateDafStatusToUnderInvestigation = new sileo.Model('hqzen', 'hr-disciplinary-investigation');
const HRDisciplinaryActionUpdateForm = new sileo.Model('hqzen', 'hr-disciplinary-action-form-update');
const PersonnelChangeNotice = new sileo.Model('hqzen', 'hr-personnel-change-notice');
const PersonnelChangeNoticeStatus = new sileo.Model('hqzen', 'hr-pcn-status');
const EmployeeDepartment = new sileo.Model('hqzen', 'hr-employee-departments');
const PCNAmazonFormData = new sileo.Model('hqzen', 'hr-pcn-amazon-form-data');
const EmploymentContractAttachmentAmazonFormData = new sileo.Model(
    'hqzen', 'employment-contract-attachment-amazon-form-data');
const PartnerEmploymentInformation = new sileo.Model('hqzen', 'partner-employment-information');
const HRForceTermination = new sileo.Model('hqzen', 'hr-force-termination');
const HRPortalOverview = new sileo.Model('hqzen', 'hr-portal-overview');
const HRResignationList = new sileo.Model('hqzen', 'hr-resignation-list');
const HRTerminationList = new sileo.Model('hqzen', 'hr-termination-list');
const HRForcedSeparationListResource = new sileo.Model('hqzen', 'hr-forced-termination-list');
const HRClearanceList = new sileo.Model('hqzen', 'hr-clearance-list');
const HRResignationPendingCount = new sileo.Model('hqzen', 'hr-resignation-count');
const HRTerminationPendingCount = new sileo.Model('hqzen', 'hr-termination-count');
const HRClearancePendingCount = new sileo.Model('hqzen', 'hr-clearance-count');
const HRResignationDetails = new sileo.Model('hqzen', 'hr-resignation-details');
const HRClearanceDetails = new sileo.Model('hqzen', 'hr-clearance-details');
const HRPortalPendingCount = new sileo.Model('hqzen', 'hr-portal-sidebar-pending-count');
const PCNMessages = new sileo.Model('hqzen', 'hr-messages');
const PCNMessageThreads = new sileo.Model('hqzen', 'hr-message-threads');
const PCNChangeLogUpdate = new sileo.Model('hqzen', 'pcn-change-log-update');
const UserPinnedCareerPolicies = new sileo.Model('hqzen', 'user-pinned-career-policies');


const state = {
    careerPolicies: [],
    selectedCareerPolicy: {},
    hasEditSchedulePermissions: false
};

const mutations = {
    setCareerPolicies(state, careerPolicies) {
        state.careerPolicies = careerPolicies;
    },

    setSelectedCareerPolicyFromExistingList(state, selectedCareerPolicyId) {
        if (state.careerPolicies.length) {
            state.selectedCareerPolicy = state.careerPolicies.find(
                policy => policy.pk == selectedCareerPolicyId);
        }
    },

    setSelectedCareerPolicy(state, selectedCareerPolicy) {
        state.selectedCareerPolicy = selectedCareerPolicy;
    },

    setSelectedEmployeeWorkforce(state, selectedEmployeeWorkforce) {
        state.selectedEmployeeWorkforce = selectedEmployeeWorkforce;
    },

    clearCareerPolicies(state) {
        state.careerPolicies = [];
    },

    setHasEditSchedulePermissions(state, userPk) {
        const hasEditSchedulePermissionsList = state.selectedCareerPolicy?.hr_admin_can_edit_team_sched || [];
        state.hasEditSchedulePermissions = hasEditSchedulePermissionsList.includes(userPk);
    }
};

const getters = {
    careerPolicies: state => state.careerPolicies,
    selectedCareerPolicy: state => state.selectedCareerPolicy,
    hasEditSchedulePermissions: state => state.hasEditSchedulePermissions
};

const actions = {
    createLeaveCredit(context, data) {
        const form = new FormData();
        form.append('employment_id', data.employment_id);
        form.append('new_credit', data.new_credit);
        form.append('remarks', data.remarks);
        form.append('employee_leave_credit_id', data.employee_leave_credit_id);

        return HRLeaveCreditChange.objects.create(form).then(response => {
            return response;
        }).catch(error => {
            console.error(error);
            return error;
        });
    },

    fetchPCNs(context, filters) {
        return PersonnelChangeNotice.objects.filter(filters);
    },

    fetchPCNDetails(context, pk) {
        return PersonnelChangeNotice.objects.get(pk);
    },

    async updatePCNStatus(context, data) {
        let pk = data.pk;
        let formData = new FormData();

        for (const key in data) {
            if (key === 'signature_file') {
                const blob = await new Promise((resolve) => {
                    data.signature_file.save(resolve);
                });

                formData.set('signature_file', blob, 'signature.png');
            } else {
                formData.append(key, data[key]);
            }
        }

        return PersonnelChangeNoticeStatus.objects.update({ pk }, formData);
    },

    fetchHRLeaveRequestList(context, filters) {
        return HRLeaveRequestList.objects.filter(filters);
    },

    fetchHRWorkforcesList(context, filters) {
        return HRWorkforcesList.objects.filter(filters);
    },

    fetchHRPortalLeaveHistory(context, filters) {
        return HRPortalLeaveHistory.objects.filter(filters);
    },

    fetchHREmployeeLeaveCreditsList(context, filters) {
        return HREmployeeLeaveCreditsList.objects.filter(filters);
    },

    fetchELCEditorsList(context, filters) {
        return HRLeavesAdminList.objects.filter(filters);
    },

    fetchCareerPolicies(context, filters) {
        return CareerPolicyList.objects.filter(filters).then(function(data) {
            context.commit('setCareerPolicies', data);
            return data;
        });
    },

    getCareerPolicy(context, pk) {
        return CareerPolicyList.objects.get(pk).then(function(data) {
            context.commit('setSelectedCareerPolicy', data);
            return data;
        });

    },

    getHRPortalLeaveDetails(context, filters) {
        return HRPortalLeaveDetails.objects.filter(filters);
    },

    getHRPortalAccountabilitiesDetails(context, filters) {
        return HRAccountabilitiesDetails.objects.filter(filters);
    },

    fetch201FilesList(context, filters) {
        return HR201FilesList.objects.filter(filters);
    },

    fetch201RequirementsCount(context, filters) {
        return HR201RequirementsCount.objects.filter(filters);
    },

    fetchHRPartnersList(context, filters) {
        return HRPartnersList.objects.filter(filters);
    },

    fetchDeactivatedPartners(context, filters) {
        return HRDeactivatedPartners.objects.filter(filters);
    },

    fetchApplicantRequirements(context, filters) {
        return ApplicantRequirements.objects.filter(filters);
    },

    rejectApplicantRequirement(context, data) {
        const formData = new FormData();
        formData.append('status', 2);
        formData.append('rejection_reason', data.rejection_reason);
        return ApplicantRequirements.objects.update({ pk: data.pk }, formData);
    },

    acceptApplicantRequirement(context, data) {
        const formData = new FormData();
        formData.append('status', 1);
        return ApplicantRequirements.objects.update({ pk: data }, formData);
    },

    deleteApplicantRequirement(context, data) {
        const formData = new FormData();
        formData.append('status', 3);
        formData.append('deletion_reason', data.deletion_reason);
        return ApplicantRequirements.objects.update({ pk: data.pk }, formData);
    },

    fetchHRAccountabilitiesList(context, filters) {
        return HRAccountabilitiesList.objects.filter(filters);
    },

    updateHRAccountability(context, data) {
        return HRAccountability.objects.update({}, data);
    },

    createHRAccountability(context, data) {
        const form = new FormData();
        for (let key in data) {
            form.append(key, data[key]);
        }
        return HRAccountability.objects.create(form);
    },

    fetchHRAccountabilityEmployees(context, filters) {
        return HRAccountabilityEmployees.objects.filter(filters);
    },

    fetchHRAccountabilityEditHistory(context, filters) {
        return HRAccountabilityEditHistory.objects.filter(filters);
    },

    getHRPartnerDetails(context, filters) {
        return HRPartnerDetails.objects.filter(filters);
    },

    fetchHRIncidentReports(context, filters) {
        return HRIncidentReports.objects.filter(filters);
    },

    async createDisciplinaryActionForm(context, data) {
        let form = new FormData();
        form.append('is_dismissed', data.is_dismissed);
        form.append('is_appealable', data.is_appealable);
        form.append('appeal_hours', data.appeal_hours);
        form.append('statement_of_facts', data.statement_of_facts);
        form.append('incident_report', data.incident_report_pk);
        form.append('attachments', JSON.stringify(data.attachments));
        form.append('location', data.location);
        form.append('description', JSON.stringify(data.description));

        if (!data.is_dismissed) {
            form.append('cleanses_on', data.cleanses_on);
            form.append('policy_action', data.policy_action_pk);
        }

        if (data.signature) {
            return new Promise((resolve, reject) => {
                data.signature.save(async (blob) => {
                    form.append('signature_file', blob, 'signature.png');
                    delete data.signature;
                    resolve(await HRDisciplinaryActionForm.objects.create(form));
                });
            });
        }
        else {
            return await HRDisciplinaryActionForm.objects.create(form);
        }
    },

    async createNoticeOfDecision(context, payload) {
        let pk = payload.pk;
        let formData = new FormData();
        for (let key in payload) {
            formData.append(key, payload[key]);
        }

        await HRDisciplinaryActionUpdateForm.objects.update({ pk }, formData);

    },

    async dismissDisciplinaryAction(context, payload) {
        let pk = payload.pk;
        let signature = payload.signature;

        let formData = new FormData();
        for (let key in payload) {
            if (key !== 'signature') {
                formData.append(key, payload[key]);
            }
        }

        return new Promise((resolve, reject) => {
            signature.save(async (blob) => {
                try {
                    formData.append('signature_file', blob, 'signature.png');

                    const response = await HRDisciplinaryActionUpdateForm.objects.update({ pk }, formData);
                    resolve(response);
                } catch (error) {
                    reject(error);
                }
            });
        });
    },

    fetchSanctions(context, filters) {
        return PolicyAction.objects.filter(filters);
    },

    fetchDafAttachmentAmazon(context, file_type) {
        return DAFAmazon.objects.filter({ file_type: file_type }).then(
            data => {
                return data.amazon;
            }
        );
    },

    fetchDafStatusCouts(context, filters) {
        return DafStatusCounts.objects.filter(filters);
    },

    fetchAllHRPortalWorkforces(context, filters) {
        return HRPortalFetchAllWorkforces.objects.filter(filters);
    },

    fetchAllHRPortalDepartments(context, filters) {
        return HRPortalFetchAllDepartments.objects.filter(filters);
    },

    fetchAllHRPortalTeams(context, filters) {
        return HRPortalFetchAllTeams.objects.filter(filters);

    },

    async updateDafAppealStatus(context, payload) {
        const pk = payload.pk;
        const formData = new FormData();
        const signature = payload.signature_file;

        for (let key in payload) {
            if (key !== 'signature_file') {
                formData.append(key, payload[key]);
            }
        }

        const saveSignature = (signature) => {
            return new Promise((resolve, reject) => {
                try {
                    signature.save((blob) => {
                        resolve(blob);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        };

        try {
            if (signature && typeof signature.save === 'function') {
                const blob = await saveSignature(signature);
                formData.append('signature_file', blob, 'signature.png');
            }

            const response = await HRDAFAppeal.objects.update({ pk }, formData);
            return response;
        } catch (error) {
            throw error;
        }
    },

    async updateDafStatusToUnderInvestigation(context, payload) {
        const pk = payload.pk;
        const formData = new FormData();

        formData.append("pk", payload.pk);
        formData.append("status", payload.status);
        formData.append("location", payload.location);

        if (payload.signature_file instanceof Blob) {
            formData.append(
                "signature_file",
                payload.signature_file,
                "signature.png"
            );
        }

        await updateDafStatusToUnderInvestigation.objects.update(
            { pk },
            formData
        );
    },

    async createPCN(context, data) {
        const form = new FormData();

        // Only handle signature if not validate_only
        if (!data.validate_only && data.signature) {
            const blob = await new Promise((resolve) => {
                data.signature.save(resolve);
            });
            form.set('signature', blob, 'signature.png');
        }

        for (const key in data) {
            if (key !== 'signature') {
                form.append(key, data[key]);
            }
        }

        return PersonnelChangeNotice.objects.create(form);
    },

    updatePCNChangeLog(context, payload) {
        const formData = new FormData();

        Object.keys(payload).forEach(key => formData.append(key, payload[key]));

        return PCNChangeLogUpdate.objects.update({ pk: payload.pk }, formData);
    },

    getPCN(context, pk) {
        return PersonnelChangeNotice.objects.get(pk);
    },

    fetchPartnerEmploymentInformation(context, pk) {
        return PartnerEmploymentInformation.objects.get(pk);
    },

    fetchEmployeeDepartments(context, filters) {
        return EmployeeDepartment.objects.filter(filters);
    },

    fetchPCNAmazonFormData(context, file_type) {
        return PCNAmazonFormData.objects.filter({ file_type: file_type }).then(amazon => {
            return amazon.amazon;
        });
    },

    fetchEmploymentContractAttachmentAmazonFormData(context) {
        return EmploymentContractAttachmentAmazonFormData.objects.filter()
            .then(amazon => amazon.amazon);
    },

    performForceTermination(context, data) {
        const formData = new FormData();

        formData.append('employment', data.employment_id);
        formData.append('reason', data.reason);
        formData.append('location', data.location);
        formData.append('signature_uuid', data.signature_id);

        return HRForceTermination.objects.create(formData);
    },

    fetchHRPortalOverviewCounts(context, filters) {
        return HRPortalOverview.objects.filter(filters);
    },

    fetchHrResignationList(context, filters) {
        return HRResignationList.objects.filter(filters);
    },

    fetchHrTerminationList(context, filters) {
        return HRTerminationList.objects.filter(filters);
    },

    fetchHrForcedSeparationListResourceList(context, filters) {
        return HRForcedSeparationListResource.objects.filter(filters);
    },

    fetchHrClearanceList(context, filters) {
        return HRClearanceList.objects.filter(filters);
    },

    fetchHrResignationPendingCount(context, filters) {
        return HRResignationPendingCount.objects.filter(filters);
    },

    fetchHrTerminationPendingCount(context, filters) {
        return HRTerminationPendingCount.objects.filter(filters);
    },

    fetchHrClearancePendingCount(context, filters) {
        return HRClearancePendingCount.objects.filter(filters);
    },

    fetchHRPortalPendingCount(context, filters) {
        return HRPortalPendingCount.objects.filter(filters);
    },

    getHRResignationDetails(context, pk) {
        return HRResignationDetails.objects.get(pk);
    },

    getHRClearanceDetails(context, pk) {
        return HRClearanceDetails.objects.get(pk);
    },

    async updateHRResignation(context, data) {
        let form = new FormData();
        form.append('approved_by', data.approved_by);
        form.append('approval_signature_uuid', data.approval_signature_uuid);
        form.append('approval_location', data.approval_location);
        return await HRResignationDetails.objects.update({ pk: data.pk }, form);
    },

    createPCNMessage(context, data) {
        const formData = new FormData();

        formData.append('attachments', data.attachments);
        formData.append('body', data.body);
        formData.append('thread', data.thread);

        return PCNMessages.objects.create(formData);
    },

    fetchPCNMessages(context, filters) {
        return PCNMessages.objects.filter(filters);
    },

    createPCNMessageThread(context, data) {
        const formData = new FormData();

        formData.append('object_id', data.object_id);
        formData.append('members', data.members);
        formData.append('title', data.title);

        return PCNMessageThreads.objects.create(formData);
    },

    getPCNMessageThread(context, pk) {
        return PCNMessageThreads.objects.get(pk);
    },

    async updateMultipleIncidentReports(context, payload) {
        let signature = payload.signature;
        let formData = new FormData();
        return new Promise((resolve, reject) => {
            signature.save(async(blob) => {
                formData.append('signature_file', blob, 'signature.png');
                delete payload.signature;
                for (let key in payload) {
                    formData.append(key, payload[key]);
                }
                resolve(await HRIncidentReports.objects.update({}, formData));
            });
        });
    },

    getUserPinnedCareerPolicies(context, pk) {
        return UserPinnedCareerPolicies.objects.get(pk);
    },

    pinCareerPolicy(context, data) {
        return UserPinnedCareerPolicies.objects.create(data);
    },

    unpinCareerPolicy(context, data) {
        return UserPinnedCareerPolicies.objects.delete(data);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions,
};
